import { ERoles, Employee } from '@/schemaTypes'
import { hasMinRole } from '@/utils/roles'

type RoleGatedSubItem = { isHidden?: boolean; minRole?: ERoles }
type RoleGatedItem<S extends RoleGatedSubItem> = {
  isHidden?: boolean
  minRole: ERoles
  items?: S[]
}

/**
 * Entries the user may see. A sub-item uses its own minRole and falls back to
 * the one of its parent; a parent with sub-items is shown as soon as one of
 * them is visible, so a single sub-item can be opened to a lower role.
 */
export function filterMenuByRole<
  S extends RoleGatedSubItem,
  I extends RoleGatedItem<S>,
>(items: I[], user: Pick<Employee, 'roles'> | null | undefined): I[] {
  return items.flatMap((item) => {
    if (item.isHidden) {
      return []
    }

    if (!item.items) {
      return hasMinRole(user, item.minRole) ? [item] : []
    }

    const visibleSubItems = item.items.filter(
      (subItem) =>
        !subItem.isHidden && hasMinRole(user, subItem.minRole ?? item.minRole),
    )

    return visibleSubItems.length ? [{ ...item, items: visibleSubItems }] : []
  })
}
